import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorRamType,
  fetchProcessorRamType,
  fetchProcessorRamTypeById,
   updateProcessorRamType,
 
} from "./thunk";

interface CategoryState {
  processor_ram_type_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_ram_type_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "ram_type",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorRamType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamType.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_ram_type_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorRamType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorRamTypeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamTypeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorRamTypeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorRamType.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_type_list = state.processor_ram_type_list.map((ram_type) =>
          ram_type.id === action.payload.id ? action.payload : ram_type
        );
      })
      .addCase(addProcessorRamType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorRamType.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_type_list = state.processor_ram_type_list.map((ram_type) =>
          ram_type.id === action.payload.id ? action.payload : ram_type
        );
      })
      .addCase(updateProcessorRamType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
  },
});

export default categorySlice.reducer;
